import { render, staticRenderFns } from "./unlock_task_dialog.vue?vue&type=template&id=58f9bc2f&scoped=true"
import script from "./unlock_task_dialog.vue?vue&type=script&lang=js"
export * from "./unlock_task_dialog.vue?vue&type=script&lang=js"
import style0 from "./unlock_task_dialog.vue?vue&type=style&index=0&id=58f9bc2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f9bc2f",
  null
  
)

export default component.exports